import { render, staticRenderFns } from "./OrgConfig.vue?vue&type=template&id=1ac2de12&scoped=true"
import script from "./OrgConfig.vue?vue&type=script&lang=js"
export * from "./OrgConfig.vue?vue&type=script&lang=js"
import style0 from "./OrgConfig.vue?vue&type=style&index=0&id=1ac2de12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac2de12",
  null
  
)

export default component.exports